import React, { useCallback } from 'react';
import { ReactSVG } from 'react-svg';
import UIButton from 'Components/UIComponents/UIButton';
import { UNDER_MAINTENANCE_START, UNDER_MAINTENANCE_STOP } from 'Utils/constants';

import UnderMaintenanceIcon from 'Assets/images/icons/undermaintenance-icon.svg';

const UnderMaintenance = () => {
  const handleRedirect = useCallback(() => {
    window.location.href = 'https://signaturely.com';
  }, []);

  return (
    <div className="underMaintenance__wrapper">
      <div className="underMaintenance">
        <div className="underMaintenance__icon">
          <ReactSVG src={UnderMaintenanceIcon} />
        </div>
        <div className="underMaintenance__info">
          <div className="underMaintenance__info-title">
            We are in scheduled maintenance.
          </div>
          <div className="underMaintenance__info-subtitle">
            {`
              Sorry for the inconvenience. We expect the maintenance to happen from ${UNDER_MAINTENANCE_START}
              to ${UNDER_MAINTENANCE_STOP} PST.
            `}
          </div>
          <div className="underMaintenance__info-button">
            <UIButton
              priority="primary"
              title="Go to Signaturely.com"
              handleClick={handleRedirect}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnderMaintenance;
